// extracted by mini-css-extract-plugin
export default {"list":"CityList_list__iITkC","btn":"CityList_btn__HmQy+"};